<script>
    import Navbutton from "../../components/reusable/buttons/navbutton.svelte";
    import { screenStore } from "../../functions/stores";
    export let y;
    let text = 'betterlifeug1@gmail.com';
  const copyContent = async () => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Email copied to clipboard');
    } catch (err) {
      console.log('Failed to copy: ', err);
    }
  }
</script>

<footer>
    <div class="bg-blue-50 h-2">
        <span class="sliding text-white" id="scroll-container">
            <div
                id="scroll-text"
                class=" px-10 text-bold flex justify-between"
            />
        </span>
    </div>
    <div style="height: 200px;" class=" w-full">
        {#if $screenStore.width > 500}
            <div class="pt-10 flex justify-between">
                <div class="md:pl-32 min-[320px]:pl-10">
                    <div class="">
                        <img class="w-20" src="/images/1.png" alt="" />
                    </div>
                    <div on:keypress on:click={()=>copyContent()} class="space-x-4 flex shadow px-2 text-sm">
                        Email : betterlifeug1@gmail.com
                    </div>
                    <div class="text-xs">
                        Click to copy
                    </div>
                    <div class="text-xs pt-3">Copyright © 2023 BetterLife</div>
                </div>
                <div class="text-center">
                    <div class="font-bold">
                        “The greatest healing therapy is friendship and love.”
                    </div>
                    <div>Hubert H.</div>
                </div>
                <div class=" md:pr-32 min-[320px]:pr-10 text-lg">
                    <div>
                        <Navbutton
                            name={"What we offer"}
                            active={false}
                            click={() => {
                                y = 1076;
                            }}
                        />
                    </div>
                    <div>
                        <Navbutton
                            name={"Back to top"}
                            active={false}
                            click={() => {
                                y = 0;
                            }}
                        />
                    </div>
                </div>
            </div>
        {:else}
            <div class="pt-10 px-10">
                <div class="text-center">
                    <div class="font-bold">
                        “The greatest healing therapy is friendship and love.”
                    </div>
                    <div>Hubert H.</div>
                </div>
                <div class="">
                    <div class="flex justify-center">
                        <img class="w-20" src="/images/1.png" alt="" />
                    </div>
                    <div class="space-x-4 flex justify-center">
                        <div on:keypress on:click={()=>copyContent()} class="space-x-4 flex shadow px-2 text-sm">
                            Email : betterlifeug1@gmail.com
                        </div>
                        <div class="text-xs">
                            Click to copy
                        </div>

                    </div>
                    <div class="text-xs py-3 flex justify-center">
                        Copyright © 2023 BetterLife
                    </div>
                </div>
            </div>
        {/if}
    </div>
</footer>

<style>
    
</style>
